var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level4-search-component"},[_c('Level4Forms'),_c('Level4CategoryMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }